document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".ec-accordion").forEach(function (btn) {

    btn.addEventListener("click", function () {

      this.classList.toggle("active");

      const contenu = this.nextElementSibling;

      if (!contenu) return;

      if (contenu.style.display === "block") {
        contenu.style.display = "none";
      } else {
        contenu.style.display = "block";
      }

    });

  });

});